module.exports = __webpack_public_path__ + "img/section-3-content_1_t_icon7_native.7f1b0fd8.png";